import { SceneGraphNode } from 'src/app/engine/models/scene-graph.model';
import { UIConfigModel } from 'src/app/story/models/ui-config.model';
import { LayerSetsModel } from 'src/app/story/models/layers.model';

// Instructs loader what to do on load complete
export class StoryAnimationModel {
    scrub?: { time: number };
    play?: {
        startChapterId?: string;
        startTime?: number;
        finishChapterId?: string;
        finishTime?: number;
        numChapters?: number;
    };
}
import { CameraModel } from '../../engine/models/camera.model';
import { Type } from 'class-transformer';

export class AssetLibrary {
    lights: string[];
    tweens: string[];
    regionMaps: string[];
    reflections: string[];
}

export class StoryModel {
    // Types -----------------------------------------------------
    @Type(() => SceneGraphNode)
    @Type(() => CameraModel)
    @Type(() => UIConfigModel)
    @Type(() => LayerSetsModel)

    // Model -----------------------------------------------------
    moduleId: string; // Just "id"
    displayName: string;
    description: string;
    camera: CameraModel;
    chapters: any[];
    stateId: string[];
    assetLibraries: AssetLibrary;
    sceneGraph: SceneGraphNode[];
    ui: UIConfigModel;
    animation: StoryAnimationModel;
    layers: LayerSetsModel;
    tags: string[];
    customData: any; // playground for experimental data
    reflections: { [key: string]: string }; // shortcut ids for use in materials.
    colorRecipes: any;

}
